module.exports = __webpack_public_path__ + "img/nap_01.0f42bc4e.jpg";